import { FileUpload, Icon, Box, type UseFileUploadReturn, Flex, Text } from '@chakra-ui/react';
import { IoCloudUpload } from 'react-icons/io5';
import { useTranslation } from 'react-i18next';
import { memo } from 'react';

export const ImportFileUpload = memo(({ fileUpload }: { fileUpload: UseFileUploadReturn }) => {
	const { t } = useTranslation();

	return (
		<FileUpload.RootProvider value={fileUpload} alignItems="stretch">
			<FileUpload.HiddenInput />
			<FileUpload.Dropzone cursor={'pointer'}>
				<FileUpload.DropzoneContent cursor={'pointer'}>
					<FileUpload.Trigger asChild>
						<Flex flexDir="column" alignItems={'center'}>
							<Icon size="md" color="fg.muted">
								<IoCloudUpload />
							</Icon>
							<Text>{t('general.drag_and_drop_file_here')}</Text>
							<Box color="fg.muted">{t('general.supported_file_types')}: .xlsx, .csv</Box>
						</Flex>
					</FileUpload.Trigger>
				</FileUpload.DropzoneContent>
			</FileUpload.Dropzone>
			<FileUpload.List clearable />
		</FileUpload.RootProvider>
	);
});
